<template>
  <div>
    <v-divider class="mb-3 mt-4"></v-divider>
    <v-chip-group column>
      <v-chip
        v-for="item in filters"
        v-if="!item.isHidden"
        :key="item.id"
        close-icon="close"
        :close="!item.preventDelete"
        :x-color="item.data.color || null"
        @click:close="handleClose(item)"
        outlined
        small
      >
        <v-icon
          v-if="item.data.icon"
          :x-color="item.data.iconColor || null"
          small
          left
        >
          {{ item.data.icon }}
        </v-icon>
        {{ item.data.text }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
export default {
  name: "AppliedFilters",

  props: {
    filters: {
      type: Array,
      required: true
    }
  },

  methods: {
    // dispatch delete event to vuex handler
    handleClose(item) {
      this.$emit("remove", item)
    }
  }
}
</script>
